import { computed, decorate, observable } from "mobx"
import AepsPool from "../js/AepsPool"
import AleasPool from "../js/AleasPool"
import BadgesPool from "../js/BadgesPool"
import DataLoading from '../js/DataLoading'
import GoalsPool from "../js/GoalsPool"
import { COUNTRIES, GAME_STATES } from '../js/ids'
import IndicatorsPool from "../js/IndicatorsPool"
import MarkersPool from "../js/MarkersPool"
import Models from "../js/Models"
import ParametersPool from "../js/ParametersPool"
import { process } from '../js/process'
import SGMSClient from "../js/SGMSClient"
import Translations from "../js/Translations"
import Trees from "../js/Trees"
import PopupStore, { POPUPS_IDS } from "./PopupStore"

const urlParams = new URLSearchParams(window.location.search);

class Store {

  gameState = GAME_STATES.LOADING
  language = window.CONFIG.languages[0]
  country = null

  scenario = null
  genericMeeting = null

  indicatorsTrees = {}

  // ACTIONS
  selectedActions = {}
  previouslySelectedActions = {}
  selectedActionsHistory = []
  indValuesHistory = []

  yearNumber = 0
  maxAepDiff = 5


  reportConfig = null
  debugMode = false

  constructor() {
    this.firstLoad()

    this.debugMode = urlParams.get('debug')

    this.t = this.t.bind(this)
  }

  firstLoad() {

    DataLoading.loadScripts()
    .then(() => DataLoading.loadData(window.CONFIG.requiredFiles))
    .then( () => {
      Translations.init()
      Models.init()
      MarkersPool.init()

      this.indicatorsTrees = Trees.init()


        let config = {
            "name" : "French farm",
            "summary" : "<center>Bienvenue dans <b>votre ferme</b>!<br>Une exploitation mixte culture-élevage dans l'ouest de la France<br><span style='font-size:80px;'>&#127805;</span> <span style='font-size:80px;'>&#128046;</span></center>",
            "initial_aeps" : {

            },
            "aleas" : [
              {
                "id" : "milk_price",
                "hazard" : 0.2,
                "minYearNum" : 2,
                "maxYearNum" : null,
                "name" : "Crisis in the dairy industry!",
                "message" : "The milk price has lowered by ₸100!",
                "effects" : [
                  {
                    "coef" : -100,
                    "operator" : "+",
                    "paramId" : "paramAn1"
                  }
                ]
              },
              {
                "id" : "summer_drought",
                "name" : "Summer drought!",
                "message" : "Maize yields decreased by 20%!<br>Yields of other cereals decreased by 15%!<br>Rapeseed, pea, faba bean, and temporary grassland yields decreased by 10%!",
                "minYearNum" : 2,
                "maxYearNum" : null,
                "hazard" : 0.2,
                "effects" : [
                  {
                    "coef" : 0.85,
                    "operator" : "*",
                    "paramId" : "indCr1"
                  },
                  {
                    "coef" : 0.85,
                    "operator" : "*",
                    "paramId" : "indCr3"
                  },
                  {
                    "coef" : 0.9,
                    "operator" : "*",
                    "paramId" : "indCr7"
                  },
                  {
                    "coef" : 0.9,
                    "operator" : "*",
                    "paramId" : "indCr8"
                  },
                  {
                    "coef" : 0.9,
                    "operator" : "*",
                    "paramId" : "indCr9"
                  },
                  {
                    "coef" : 0.8,
                    "operator" : "*",
                    "paramId" : "indCr10"
                  },
                  {
                    "coef" : 0.85,
                    "operator" : "*",
                    "paramId" : "indCr12"
                  },
                  {
                    "coef" : 0.9,
                    "operator" : "*",
                    "paramId" : "indCr13"
                  }
                ]
              }
            ],
            "parameters" : [ ],
            "goals" : [
              {
                "id" : "durability_1",
                "group" : "durability",
                "title" : "good economic sustainability (> 0.6)",
                "description" : "",
                "indicator" : "indT42",
                "operator" : ">",
                "value" : 0.6,
                "isVictory" : true
              },
              {
                "id" : "durability_2",
                "group" : "durability",
                "title" : "and good environmental sustainability (> 0.6)",
                "description" : "",
                "indicator" : "indT24",
                "operator" : ">",
                "value" : 0.6,
                "isVictory" : true
              },
              {
                "id" : "durability_3",
                "group" : "durability",
                "title" : "and good social sustainability (> 0.6)",
                "description" : "",
                "indicator" : "indT37",
                "operator" : ">",
                "value" : 0.6,
                "isVictory" : true
              },
              {
                "id" : "durability_4",
                "group" : "durability",
                "title" : "after 10 years",
                "description" : "",
                "indicator" : "indYearNumber",
                "operator" : ">",
                "value" : 10,
                "isVictory" : true
              },
              {
                "id" : "deficit",
                "group" : "deficit",
                "title" : "the Cumulated investment capacity is negative for more than 3 years",
                "description" : "",
                "indicator" : "indF91inf0",
                "operator" : ">",
                "value" : 3,
                "isVictory" : false
              },
              {
                "id" : "duration",
                "group" : "duration",
                "title" : "you did not achieve the goals after 10 years",
                "description" : "",
                "indicator" : "indYearNumber",
                "operator" : ">",
                "value" : 10,
                "isVictory" : false
              }
            ],
            "models" : [ ],
            "MeetingPeriods" : [
              {
                "DurationSec" : 300
              }
            ],
            "Scores" : [
              {
                "id" : "indT47",
                "name" : "Score"
              },
              {
                "id" : "indGameWon",
                "name" : "Game won"
              },
              {
                "id" : "indT43",
                "name" : "Sustainability"
              },
              {
                "id" : "indT42",
                "name" : "Economic sustainability"
              },
              {
                "id" : "indT24",
                "name" : "Environmental sustainability"
              },
              {
                "id" : "indT37",
                "name" : "Social sustainability"
              },
              {
                "id" : "indYearNumber",
                "name" : "Final year"
              }
            ],
            "ConfigName" : "French farm",
            "MeetingType" : "GameMeeting",
            "MeetingActivity" : {
              "ComponentMeetingSequencer" : {
                "Sequence" : {
                  "Periods" : [
                    {
                      "DurationSec" : 300,
                      "SpeedFactor" : 1
                    }
                  ]
                }
              },
              "ComponentMeetingSequencerController" : {

              },
              "ComponentMeetingSequencerStatus" : {

              }
            }
          }
          this.secondLoad(config, true)


      // this.gameState = GAME_STATES.LOADED

      // SGMSClient.init(window.CONFIG.vertexConfig.ServerIP, window.CONFIG.vertexConfig.ServerPort)

    })
    .catch(err => {
      console.log("err", err)
    })
  }

  secondLoad(scenario, genericMeeting = false) {

    this.gameState = GAME_STATES.LOADING

    this.genericMeeting = genericMeeting

    // le setTimeout permet de mettre à jour l'ui avant les process afin que le loader tourne
    setTimeout(()=> {
      DataLoading
      .loadTranslationsFiles(window.CONFIG.translationsFiles(this.language))
      .then(()=>{
        this.init(scenario)
      })
    }, 50)
  }

  init(scenario) {
    this.scenario = scenario

    this.previouslySelectedActions = {}
    this.selectedActionsHistory = []
    this.indValuesHistory = []
    this.yearNumber = 0




    ParametersPool.init()
    ParametersPool.applyScenario(scenario)

    this.maxAepDiff = ParametersPool.getDef('paramF57')
    this.country = COUNTRIES[ParametersPool.getDef("paramBackground")]

    IndicatorsPool.init()
    IndicatorsPool.applyTranslations()


    AepsPool.init()
    AepsPool.applyTranslations()
    AepsPool.applyScenario(scenario)
    this.selectedActions = AepsPool.activeAtStart

    // les aleas sont définis exclusivement dans les scenarios
    AleasPool.applyScenario(scenario)

    // les goals sont définis exclusivement dans les scenarios
    GoalsPool.applyScenario(scenario)


    Models.applyScenario(scenario)


    BadgesPool.init(DataLoading.badges)


    if(SGMSClient.userCustomDatas && SGMSClient.userCustomDatas.badges) {
      BadgesPool.applySavedValues(SGMSClient.userCustomDatas.badges)
    }

    if(SGMSClient.userCustomDatas && SGMSClient.userCustomDatas.indicators) {
      IndicatorsPool.applySavedValues(SGMSClient.userCustomDatas.indicators)
    }

    if(!this.isMeetingInfinite) {
      SGMSClient.stopInfosInterval()
      SGMSClient.startInfosInterval()
      PopupStore.showMeetingOverlay()
    }

    this.goToNextYear() // automatiquement faire la première année
    this.gameState = GAME_STATES.INGAME

    PopupStore.open(POPUPS_IDS.DESCRIPTION)



  }

  sendScores(score_id = null) {
    return
    // const scores = {}
    // this.scenario.Scores.forEach(s => {
    //   let val = IndicatorsPool.getIndicatorValue(s.id, true)
    //   if(val !== undefined) scores[s.id] = val
    // })

    // SGMSClient.userMeetingSetScores(scores, score_id)
  }

  saveCustomDatas() {
    SGMSClient.userUpdateCustomData({
      badges: BadgesPool.all,
      indicators: {
        indNbWonGames: IndicatorsPool.getIndicatorValue("indNbWonGames"),
        indNbWonGames_fr: IndicatorsPool.getIndicatorValue("indNbWonGames_fr"),
        indNbWonGames_be: IndicatorsPool.getIndicatorValue("indNbWonGames_be"),
        indNbWonGames_it: IndicatorsPool.getIndicatorValue("indNbWonGames_it"),
        indNbWonGames_pl: IndicatorsPool.getIndicatorValue("indNbWonGames_pl")
      }
    })
  }

  get allChosenAepIds() {
    return [...this.selectedActionsHistory, this.prevSelectedAepIds]
  }

  get currentSelectedAepIds() { return Object.values(this.selectedActions) }
  get prevSelectedAepIds() { return Object.values(this.previouslySelectedActions) }
  get aepIdsDiff() { return this.currentSelectedAepIds.filter(id => !this.prevSelectedAepIds.includes(id)) }

  get aepIdsDiffCategs() {
    return this.aepIdsDiff.map(aepId => {
      let categ = null
      AepsPool.categs.forEach(c => {
        if(c.aeps.find(aep => aep.id === aepId)) categ = c.name
      })
      return categ
    })
  }

  get remainingAepChanges() {
    return this.maxAepDiff - this.aepIdsDiff.length
  }



  getSelectedAepId(categName) { return this.selectedActions[categName] }
  setSelectedAep (categName, aepId ) {
    if(this.isGameOver) return
    this.selectedActions[categName] = aepId
  }

  getPrevSelectedAepId(categName) { return this.previouslySelectedActions[categName] }



  get allIndValuesHistory() { return  [...this.indValuesHistory, IndicatorsPool.indicatorsRoundedValues] }

  /**********************************/
  goToNextYear() {
    const prevSelActionsIds = Object.values(this.previouslySelectedActions)

    // on enregistre la liste des ids d'AEP choisies
    if(prevSelActionsIds.length > 0) {
      this.selectedActionsHistory.push(prevSelActionsIds)
    }
    this.previouslySelectedActions = Object.assign({}, this.selectedActions)

    // ici on vérifie si un alea survient
    AleasPool.checkAll()

    // on process les aep choisies cette année (N)
    let newIndicatorsValues = process(this.yearNumber,Models.all,this.selectedActions,prevSelActionsIds)

    // on duplique this.indicatorsValues
    // on l'enregistre dans l'historique
    let oldIndValues =  IndicatorsPool.indicatorsRoundedValues

    this.indValuesHistory.push(oldIndValues)
    // on assigne les nouvelles valeurs
    IndicatorsPool.values = newIndicatorsValues

    // this.checkForGameOver()
    var goalsPoolGameFinished = GoalsPool.checkAll()
    IndicatorsPool.setIndicatorValue("indGameWon", 0)

    if(goalsPoolGameFinished) {
      // on incrémente le numéro de l'année
      this.yearNumber++
      this.handleGameFinished(goalsPoolGameFinished)
    }
    else {
      // ouverture de la popup Report automatique, sauf pour le premier tour
      if(this.yearNumber > 0 && !this.isGameOver) {
        PopupStore.open(POPUPS_IDS.REPORT)
      }

      // on incrémente le numéro de l'année
      this.yearNumber++
      

      BadgesPool.recalculate()

      this.sendScores()

    }

  }

  handleGameFinished(gameState) {
    this.gameState = gameState

    if(this.gameState === GAME_STATES.OVER_VICTORY) {
      IndicatorsPool.values["indNbWonGames"]++

      if(ParametersPool.getDef("paramBackground") === 0) { IndicatorsPool.values["indNbWonGames_fr"]++ }
      if(ParametersPool.getDef("paramBackground") === 1) { IndicatorsPool.values["indNbWonGames_be"]++ }
      if(ParametersPool.getDef("paramBackground") === 2) { IndicatorsPool.values["indNbWonGames_it"]++ }
      if(ParametersPool.getDef("paramBackground") === 3) { IndicatorsPool.values["indNbWonGames_pl"]++ }

      IndicatorsPool.setIndicatorValue("indGameWon", 1)
      this.saveCustomDatas()


      this.sendScores("highscores")

    } else {
      IndicatorsPool.setIndicatorValue("indGameWon", -1)
      this.sendScores()
    }

    PopupStore.open(POPUPS_IDS.GAME_OVER)

  }

  get isGameOver() { return this.gameState === GAME_STATES.OVER_VICTORY || this.gameState === GAME_STATES.OVER_DEFEAT }

  get isGenericMeeting() { return !!this.genericMeeting }
  get isMeetingInfinite() {
    if(this.scenario && this.scenario.MeetingActivity && this.scenario.MeetingActivity.ComponentMeetingSequencer)  return false
    return true
  }



  restartGame() {
    PopupStore.closeAll()
    this.init(this.scenario)
  }


  t(key, defaultText = null, return_english = true) {
    let val = Translations.get(key, this.language, return_english)
    if(val) return val
    // ici on n'a pas touvé la trad, on regarde dans les aep
    let aepname = AepsPool.getAepName(key)
    if(aepname) return aepname
    // ici c'est pas une trad ni une aep...
    return defaultText !== null ? defaultText : key
  }


}


decorate(Store, {
  gameState: observable,
  yearNumber: observable,
  selectedActions: observable,
  previouslySelectedActions: observable,
  aepActiveState: observable,
  language: observable,
  isGenericMeeting: computed,

  allChosenAepIds: computed,
  currentSelectedAepIds: computed,
  prevSelectedAepIds: computed,
  aepIdsDiff: computed,
  remainingAepChanges: computed,
  aepIdsDiffCategs: computed,
  isMeetingInfinite: computed

})


export const store = new Store();
